import { render, staticRenderFns } from "./modalVerSeleccionados.vue?vue&type=template&id=80037614&"
import script from "./modalVerSeleccionados.vue?vue&type=script&lang=js&"
export * from "./modalVerSeleccionados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports